'use strict';
import React from 'react';
import flux from 'utils/flux';

var ImageViewerButtons = React.createClass({
    displayName: 'ImageViewerButtons',

    render() {
        return (
            <div className="image__viewer__buttons">
                <button onClick={this.props.zoomImageIn}
                    title={flux.t('zoom-in')}>
                    <div className="switch__button">
                        <i className="zoom-in" />
                    </div>
                </button>
                <button onClick={this.props.zoomImageOut}
                    title={flux.t('zoom-out')}>
                    <div className="switch__button">
                        <i className="zoom-out" />
                    </div>
                </button>
                <button onClick={this.props.fitToWidth}
                    title={flux.t('fit-to-width')}>
                    <div className="switch__button">
                        <i className="full-screen" />
                    </div>
                </button>
                <button onClick={this.props.fitToPage}
                    title={flux.t('fit-to-page')}>
                    <div className="switch__button">
                        <i className="expand" />
                    </div>
                </button>
            </div>
        )
    }
});


module.exports = ImageViewerButtons;


// WEBPACK FOOTER //
// ./app/components/imageViewer/imageViewerButtons.jsx